<template>
	<TheLoader :isLoading="loading" />
	<div class="row">
		<div class="col-md-2"></div>
		<div class="col-md-8">
			<div class="card card-info">
				<div class="card-header">
					<h3 class="card-title"><i class="fas fa-key mr-2"></i> {{ $t('labels.changePassword') }}</h3>
					<div class="card-tools"></div>
				</div>
				<div class="card-body form-horizontal">
					<form>
						<div class="card-body">
							<div class="form-group row">
								<label class="col-sm-4 col-form-label">
									{{ $t('labels.oldPassword') }} <span class="text-danger">(*)</span>
								</label>
								<div class="col-sm-8">
									<input v-if="showPassword" type="text" :class="['form-control', { 'is-invalid': errors.password }]" :placeholder="$t('labels.enterOldPassword')" v-model="model.password" />
									<input v-else type="password" autocomplete="off" :class="['form-control', { 'is-invalid': errors.password }]" :placeholder="$t('labels.enterOldPassword')" v-model="model.password" />
									<div class="text-danger" v-if="errors.password">{{ errors.password }}</div>
								</div>
							</div>
							<div class="form-group row">
								<label class="col-sm-4 col-form-label">
									{{ $t('labels.newPassword') }} <span class="text-danger">(*)</span></label>
								<div class="col-sm-8">
									<input v-if="showPassword" type="text" :class="['form-control', { 'is-invalid': errors.passwordNew }]" :placeholder="$t('labels.enterNewPassword')" v-model="model.passwordNew" />
									<input v-else type="password" autocomplete="off" :class="['form-control', { 'is-invalid': errors.passwordNew }]" :placeholder="$t('labels.enterNewPassword')" v-model="model.passwordNew" />
									<div class="text-danger" v-if="errors.passwordNew">{{ errors.passwordNew }}</div>
								</div>
							</div>
							<div class="form-group row">
								<label class="col-sm-4 col-form-label">
									{{ $t('labels.confirmNewPassword') }} <span class="text-danger">(*)</span></label>
								<div class="col-sm-8">
									<input v-if="showPassword" type="text" :class="['form-control', { 'is-invalid': errors.passwordNewConfirmed }]" :placeholder="$t('labels.enterConfirmNewPassword')" v-model="model.passwordNewConfirmed" />
									<input v-else type="password" autocomplete="off" :class="['form-control', { 'is-invalid': errors.passwordNewConfirmed }]" :placeholder="$t('labels.enterConfirmNewPassword')" v-model="model.passwordNewConfirmed" />
									<div class="text-danger" v-if="errors.passwordNewConfirmed">{{ errors.passwordNewConfirmed }}</div>
								</div>
							</div>
							<div class="form-group row">
								<label class="col-sm-4 col-form-label"></label>
								<div class="col-sm-8">
									<div class="custom-control custom-checkbox">
										<input class="custom-control-input" type="checkbox" id="checkboxShowPassword" @click="toggleShow()">
										<label for="checkboxShowPassword" class="custom-control-label text-primary">Hiển thị mật khẩu</label>
									</div>
								</div>
							</div>
						</div>
					</form>
				</div>
				<div class="card-footer">
					<button type="button" class="btn btn-outline-secondary" @click="onReset">Reset</button>
					<button type="button" class="btn btn-outline-info float-right" @click="onSubmit" :disabled="submitted">Đổi mật khẩu</button>
				</div>
			</div>
		</div>
		<div class="col-md-2"></div>
	</div>

</template>

<script>
	import $ from 'jquery';
	import { mapState, mapActions } from 'vuex';

	export default {
		name: 'TheChangePassword',
		data() {
			return {
				errors: {
					password: null,
					passwordNew: null,
					passwordNewConfirmed: null
				},
				model: {
					password: null,
					passwordNew: null,
					passwordNewConfirmed: null
				},
				showPassword: false,
				submitted: false,
				loading: false,
			}
		},
		methods: {
			...mapActions('header', ['setupHeader',]),
			...mapActions('authentication', ['changePassword',]),
			setup() {
				let header = 'Thay đổi mật khẩu';
				this.setupHeader({ header });
			},
			initializeSelect2() {
				$(".select2").select2()
				$(".select2bs4").select2({
					theme: "bootstrap4",
				});
			},
			validate() {
				let isValid = true
				this.errors = {
					password: null,
					passwordNew: null,
					passwordNewConfirmed: null
				}
				if (!this.model.password) {
					this.errors.password = this.$t('labels.enterOldPassword');
					isValid = false;
				}
				if (!this.model.passwordNew) {
					this.errors.passwordNew = this.$t('labels.enterNewPassword');
					isValid = false;
				}
				if (!this.model.passwordNewConfirmed) {
					this.errors.passwordNewConfirmed = this.$t('labels.enterConfirmNewPassword');
					isValid = false;
				}
				if (this.model.passwordNewConfirmed != this.model.passwordNew) {
					this.errors.passwordNewConfirmed = this.$t('labels.wrongEnterConfirmNewPassword');
					isValid = false;
				}
				return isValid;
			},
			async onSubmit() {
				this.submitted = true;
				this.loading = true;
				if (this.validate()) {
					let password = this.model.password;
					let passwordNew = this.model.passwordNew;
					let passwordNewConfirmed = this.model.passwordNewConfirmed;
					let res = await this.changePassword({ password, passwordNew, passwordNewConfirmed });
					if (res) this.onReset();
				}
				this.submitted = false;
				this.loading = false;
			},
			onReset() {
				this.errors = {
					password: null,
					passwordNew: null,
					passwordNewConfirmed: null
				}
				this.model = {
					password: null,
					passwordNew: null,
					passwordNewConfirmed: null
				}
			},
			toggleShow() {
				this.showPassword = !this.showPassword;
			}
		},
		mounted() {
			this.initializeSelect2();
			this.setup();
		}
	}
</script>

<style></style>